import { Box, Button, CircularProgress, Grid } from '@mui/material';
import { Form, Formik } from 'formik';
import React, { memo, useState } from 'react';
import Textfield from '../../components/input/Textfield';
import * as Yup from 'yup';
import { apiRequest } from '../../utils/api';
import { useDispatch } from 'react-redux';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { fetchVendorData } from '../../redux/slices/vendorSlice';

const AddNew = ({ onClose }) => {
    const dispatch = useDispatch();
    const [loading, setLoading] = useState(false);

    const INITIAL_FORM_STATE = {
        name: ''
    };

    const FORM_VALIDATION = Yup.object().shape({
        name: Yup.string().trim().required('Required')
    });

    const handleSubmit = async (values) => {
        try {
            const resp = await apiRequest('post', 'vendors', values);

            if (resp?.data) {
                onClose();
                dispatch(fetchVendorData());
            }
        } catch (error) {
            toast.error(error?.response?.data?.message ?? error?.response?.data ?? error?.message);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div>
            <Formik
                initialValues={{
                    ...INITIAL_FORM_STATE
                }}
                validationSchema={FORM_VALIDATION}
                onSubmit={(values, { resetForm }) => {
                    setLoading(true);
                    handleSubmit(values, resetForm);
                }}
            >
                <Form>
                    <Grid container direction="row" spacing={2}>
                        <Grid item lg={12} md={12} sm={12} xs={12}>
                            <Textfield name="name" label="Name" />
                        </Grid>
                    </Grid>

                    <Box sx={styles.btnContainer}>
                        {loading ? (
                            <CircularProgress size={25} color="inherit" />
                        ) : (
                            <>
                                {/* -------------- onClick will call the onClose function that closes the History Modal */}
                                <Button onClick={onClose} variant="text" sx={{ color: 'red' }}>
                                    Cancel
                                </Button>

                                {/* -----------  change button title on the basis of history status */}
                                <Button type="submit" variant="text">
                                    Save
                                </Button>
                            </>
                        )}
                    </Box>
                </Form>
            </Formik>
        </div>
    );
};

export default memo(AddNew);

const styles = {
    loadingContainer: {
        height: 400,
        width: '100%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
    },
    btnContainer: {
        display: 'flex',
        direction: 'row',
        gap: 1,
        marginTop: 1,
        justifyContent: 'flex-end'
    }
};
